
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import bindAll from 'lodash.bindall';
import virtualBlockInfo from './virtual-block-info';
import {closeWhiteList} from '../../reducers/modals';
import RealBlockList from './real-block-list';
import Box from '../box/box.jsx';
import styles from './white-list.css';


class WhiteList extends React.Component {
    constructor (props) {
        super(props);
    }
    componentDidMount () {}
    handleClick (e) {

    }
    render () {
        const {media, toolboxXML, vm, onRequestClose} = this.props;
        return (
            <Box className={styles.wrapper}>
                <RealBlockList
                    toolboxXML={toolboxXML}
                    media={media}
                    vm={vm}
                    onRequestClose={onRequestClose}
                />
            </Box>
        );
    }
}

WhiteList.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    setEditState: PropTypes.func,
    vm: PropTypes.shape({
        setToolbox: PropTypes.func,
        toolboxXML: PropTypes.string
    })
};

const mapStateToProps = state => ({
    toolboxXML: state.scratchGui.toolbox.toolboxXML,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = dispatch => ({
    onRequestClose: () => dispatch(closeWhiteList())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WhiteList);

export const intrinsicBlocksMap = virtualBlockInfo;
